import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}]]

const IconPercentage0 = createReactComponent('outline', 'percentage-0', 'Percentage0', __iconNode);

export default IconPercentage0;